import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./HeroSlider.scss";

// import img1 from '../../assets/collage_img/blc.jpeg'
import img1 from '../../assets/collage_img/clg.jpg'
import img2 from '../../assets/home/university.jpg'
import img3 from '../../assets/home/Samford.jpg'
import img4 from '../../assets/collage_img/blc3.jpeg'
import img5 from '../../assets/collage_img/blc4.jpeg'
// import img6 from '../../assets/collage img/main (13).jpeg'


const slides = [
  {
    id: 1,
    image: img1,
    subtitle: "Welcome to Our Law College",
    title: "We Build <span class='highlight'>Dreams</span>",
    description: "Your success is our mission. Let’s grow together. Cut down the intermediaries and grow profits with our ",
    primaryBtn: "Get Started",
    secondaryBtn: "Learn More",
  },
  {
    id: 2,
    image: img4,
    subtitle: "Our College",
    title: "Creative <span class='highlight'>Solutions</span>",
    description: "Your success is our mission. Let’s grow together. Cut down the intermediaries and grow profits.",
    primaryBtn: "View more",
    secondaryBtn: "Contact Us",
  },
  {
    id: 3,
    image: img5,
    subtitle: "Join Us",
    title: "Let’s <span class='highlight'>Collaborate</span>",
    description: "Your success is our mission. Let’s grow together. Cut down the intermediaries and grow profits.",
    primaryBtn: "Join Now",
    secondaryBtn: "Contact Us",
  },
];

const HeroSlider = () => {
      const navigate = useNavigate();

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000); // change every 5 sec
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-slider">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`slide ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }} >
          <div className="overlay"></div>
          <div className="content">
            {/* <h3 className="subtitle">{slide.subtitle}</h3> */}
            {/* <h1 className="title" dangerouslySetInnerHTML={{ __html: slide.title }} /> */}
            {/* <p className="description">{slide.description}</p> */}
            {/* <button className="btn primary" onClick={() => navigate("/intrship")}>{slide.primaryBtn}</button> */}
            {/* <button className="btn secondary" onClick={() => navigate("/contact")}>{slide.secondaryBtn}</button> */}
          </div>
        </div>
      ))}
    </section>
  );
};

export default HeroSlider;
